// Auto-generated by gatsby-theme onPreBootstrap. Do not edit.
export const addedProtectionBlackSvgSrc = "/svg/black/addedProtectionBlackSvgSrc.svg";
export const buffBlackSvgSrc = "/svg/black/buffBlackSvgSrc.svg";
export const deepHydrationBlackSvgSrc = "/svg/black/deepHydrationBlackSvgSrc.svg";
export const dualHeadSystemBlackSvgSrc = "/svg/black/dualHeadSystemBlackSvgSrc.svg";
export const fileEdgeBlackSvgSrc = "/svg/black/file-edge-black.svg";
export const ingrownHairBlackSvgSrc = "/svg/black/ingrownHairBlackSvgSrc.svg";
export const innovatorsBlackSvgSrc = "/svg/black/innovatorsBlackSvgSrc.svg";
export const lawnMowerBlackSvgSrc = "/svg/black/lawnMowerBlackSvgSrc.svg";
export const leaveShineBlackSvgSrc = "/svg/black/leaveShineBlackSvgSrc.svg";
export const lubricationBlackSvgSrc = "/svg/black/lubricationBlackSvgSrc.svg";
export const multiGlideBlackSvgSrc = "/svg/black/multiGlideBlackSvgSrc.svg";
export const noOuchBlackSvgSrc = "/svg/black/noOuchBlackSvgSrc.svg";
export const publicPrivatesBlackSvgSrc = "/svg/black/publicPrivatesBlackSvgSrc.svg";
export const satinWaistbandBlackSvgSrc = "/svg/black/satinWaistbandBlackSvgSrc.svg";
export const setVibeBlackSvgSrc = "/svg/black/setVibeBlackSvgSrc.svg";
export const skinsafeBlackSvgSrc = "/svg/black/skinsafeBlackSvgSrc.svg";
export const trustedBlackSvgSrc = "/svg/black/trustedBlackSvgSrc.svg";
export const waterBlackSvgSrc = "/svg/black/waterBlackSvgSrc.svg";
export const allureLogoSvgSrc = "/svg/company-logos/allureLogoSvgSrc.svg";
export const esquireLogoSvgSrc = "/svg/company-logos/esquireLogoSvgSrc.svg";
export const forbesLogoSvgSrc = "/svg/company-logos/forbesLogoSvgSrc.svg";
export const glamourLogoSvgSrc = "/svg/company-logos/glamourLogoSvgSrc.svg";
export const gqLogoSvgSrc = "/svg/company-logos/gqLogoSvgSrc.svg";
export const mensHealthLogoSvgSrc = "/svg/company-logos/menshealthLogoSvgSrc.svg";
export const wiredLogoSvgSrc = "/svg/company-logos/wiredLogoSvgSrc.svg";
export const detachablePadSvgSrc = "/svg/dome-care/detachablePadSvgSrc.svg";
export const glowingSvgSrc = "/svg/dome-care/glowingSvgSrc.svg";
export const padLubricationSvgSrc = "/svg/dome-care/padLubricationSvgSrc.svg";
export const palmItSvgSrc = "/svg/dome-care/palmItSvgSrc.svg";
export const smoothFinishSvgSrc = "/svg/dome-care/smoothFinishSvgSrc.svg";
export const sootheGroovesSvgSrc = "/svg/dome-care/sootheGroovesSvgSrc.svg";
export const sootheOperatorSvgSrc = "/svg/dome-care/sootheOperatorSvgSrc.svg";
export const glassdoorLogoSrc = "/svg/featured/glassdoor.svg";
export const studentBeansLogoSrc = "/svg/featured/student-beans.svg";
export const unidaysLogoSrc = "/svg/featured/unidays.svg";
export const auFlagSvgSrc = "/svg/flags/au.svg";
export const caFlagSvgSrc = "/svg/flags/ca.svg";
export const euFlagSvgSrc = "/svg/flags/eu.svg";
export const sgFlagSvgSrc = "/svg/flags/sg.svg";
export const ukFlagSvgSrc = "/svg/flags/uk.svg";
export const usFlagSvgSrc = "/svg/flags/us.svg";
export const zaFlagSvgSrc = "/svg/flags/za.svg";
export const aMinuteSvgSrc = "/svg/gradient/aMinuteSvgSrc.svg";
export const addedProtectionSvgSrc = "/svg/gradient/added-protection.svg";
export const alcoholFreeSvgSrc = "/svg/gradient/alcoholFreeSvgSrc.svg";
export const aluminumFreeSvgSrc = "/svg/gradient/aluminum-free.svg";
export const antibacterialSiliconeSvgSrc = "/svg/gradient/antibacterialSiliconeSvgSrc.svg";
export const batterySvgSrc = "/svg/gradient/battery.svg";
export const bladesAltSvgSrc = "/svg/gradient/blades-alt.svg";
export const bladesSvgSrc = "/svg/gradient/blades.svg";
export const buffSvgSrc = "/svg/gradient/buff.svg";
export const calendarSvgSrc = "/svg/gradient/calendar.svg";
export const chargeTimeSvgSrc = "/svg/gradient/charge-time.svg";
export const cleanSvgSrc = "/svg/gradient/cleanSvgSrc.svg";
export const clearYourHeadSvgSrc = "/svg/gradient/clear-your-head.svg";
export const clippersSvgSrc = "/svg/gradient/clippers.svg";
export const cologneQualitySvgSrc = "/svg/gradient/cologne-quality.svg";
export const confirmationSvgSrc = "/svg/gradient/confirmationSvgSrc.svg";
export const crownSvgSrc = "/svg/gradient/crown.svg";
export const crueltyFreeSvgSrc = "/svg/gradient/cruelty-free.svg";
export const currentPointsSvgSrc = "/svg/gradient/current-points.svg";
export const deepHydrationSvgSrc = "/svg/gradient/deep-hydration.svg";
export const dermatologistTestedSvgSrc = "/svg/gradient/dermatologistTestedSvgSrc.svg";
export const detailSvgSrc = "/svg/gradient/detail.svg";
export const discountSvgSrc = "/svg/gradient/discount.svg";
export const dollarSvgSrc = "/svg/gradient/dollar.svg";
export const driesClearSvgSrc = "/svg/gradient/dries-clear.svg";
export const dualHeadSystemSvgSrc = "/svg/gradient/dualHeadSystemSvgSrc.svg";
export const dualSvgSrc = "/svg/gradient/dual.svg";
export const dyeFreeSvgSrc = "/svg/gradient/dye-free.svg";
export const engraveSvgSrc = "/svg/gradient/engrave.svg";
export const exfoliationSvgSrc = "/svg/gradient/exfoliation.svg";
export const featherSvgSrc = "/svg/gradient/feather.svg";
export const fileEdgeSvgSrc = "/svg/gradient/fileEdgeSvgSrc.svg";
export const financeSvgSrc = "/svg/gradient/finance.svg";
export const frontFlySvgSrc = "/svg/gradient/front-fly.svg";
export const gearGradientSvgSrc = "/svg/gradient/gear.svg";
export const goodCuticlesSvgSrc = "/svg/gradient/goodCuticlesSvgSrc.svg";
export const gradientRingSvgSrc = "/svg/gradient/gradient-ring.svg";
export const groomOnGoSvgSrc = "/svg/gradient/groom-on-go.svg";
export const highVisibilitySvgSrc = "/svg/gradient/high-visibility.svg";
export const HistorySvgSrc = "/svg/gradient/HistorySvgSrc.svg";
export const holidaySvgSrc = "/svg/gradient/holiday.svg";
export const ingrownHairSvgSrc = "/svg/gradient/ingrown-hair.svg";
export const insuranceSvgSrc = "/svg/gradient/insurance.svg";
export const jewelPouchSvgSrc = "/svg/gradient/jewel-pouch.svg";
export const latherSvgSrc = "/svg/gradient/lux-lather.svg";
export const liIonCircleSvgSrc = "/svg/gradient/li-ion-circle.svg";
export const lifetimePointsSvgSrc = "/svg/gradient/lifetime-points.svg";
export const lm5FoilBladeSvgSrc = "/svg/gradient/lm5-foil-blade.svg";
export const lm5TrimmerBladeSvgSrc = "/svg/gradient/lm5-trimmer-blade.svg";
export const lockSvgSrc = "/svg/gradient/icon-lock.svg";
export const lubricationSvgSrc = "/svg/gradient/lubrication.svg";
export const magnetSvgSrc = "/svg/gradient/magnet.svg";
export const medicalSvgSrc = "/svg/gradient/medical.svg";
export const mentalHealthSvgSrc = "/svg/gradient/mental-health.svg";
export const messageSvgSrc = "/svg/gradient/message.svg";
export const microCombSvgSrc = "/svg/gradient/micro-comb.svg";
export const microFabricSvgSrc = "/svg/gradient/micro-fabric.svg";
export const multiGlideSvgSrc = "/svg/gradient/multi-glide.svg";
export const noGermsSvgSrc = "/svg/gradient/no-germs.svg";
export const nonGreasyFormulaSvgSrc = "/svg/gradient/nonGreasyFormulaSvgSrc.svg";
export const noOuchSvgSrc = "/svg/gradient/no-ouch.svg";
export const oneStrokeSvgSrc = "/svg/gradient/one-stroke.svg";
export const otherReplenishmentsSvgSrc = "/svg/gradient/otherReplenishmentsSvgSrc.svg";
export const parabenFreeSvgSrc = "/svg/gradient/parabenFreeSvgSrc.svg";
export const pendingPointsSvgSrc = "/svg/gradient/pending-points.svg";
export const pencilSvgSrc = "/svg/gradient/pencil.svg";
export const persevereSvgSrc = "/svg/gradient/persevere.svg";
export const pivotSvgSrc = "/svg/gradient/pivot.svg";
export const polishSvgSrc = "/svg/gradient/polish.svg";
export const precision2SvgSrc = "/svg/gradient/precision2.svg";
export const premiumHydrationSvgSrc = "/svg/gradient/premiumHydrationSvgSrc.svg";
export const presentSvgSrc = "/svg/gradient/present.svg";
export const refreshRootsSvgSrc = "/svg/gradient/refresh-roots.svg";
export const refreshSvgSrc = "/svg/gradient/refresh.svg";
export const refinedSvgSrc = "/svg/gradient/refined.svg";
export const satinWaistbandSvgSrc = "/svg/gradient/satin-waistband.svg";
export const setVibeSvgSrc = "/svg/gradient/setVibeSvgSrc.svg";
export const shippingSvgSrc = "/svg/gradient/shipping.svg";
export const sickLeaveSvgSrc = "/svg/gradient/sick-leave.svg";
export const signatureScentSvgSrc = "/svg/gradient/signature-scent.svg";
export const skinToneSvgSrc = "/svg/gradient/skinToneSvgSrc.svg";
export const skincareKitsSvgSrc = "/svg/gradient/skincareKitsSvgSrc.svg";
export const skinsafeSvgSrc = "/svg/gradient/skinsafe.svg";
export const smileHeartSvgSrc = "/svg/gradient/smile-heart.svg";
export const sonicCleanSvgSrc = "/svg/gradient/sonicCleanSvgSrc.svg";
export const spiralSvgSrc = "/svg/gradient/spiral.svg";
export const spotlightSvgSrc = "/svg/gradient/icon-spotlight.svg";
export const steelSvgSrc = "/svg/gradient/steel.svg";
export const sulfateFreeSvgSrc = "/svg/gradient/sulfateFreeSvgSrc.svg";
export const titaniumSvgSrc = "/svg/gradient/titanium.svg";
export const toolCaseSvgSrc = "/svg/gradient/tool-case.svg";
export const trophySvgSrc = "/svg/gradient/trophy.svg";
export const tweezerSvgSrc = "/svg/gradient/tweezer.svg";
export const twoInOneSvgSrc = "/svg/gradient/two-in-one.svg";
export const ultraPremiumSvgSrc = "/svg/gradient/ultra-premium.svg";
export const ultraPremiumCircleSvgSrc = "/svg/gradient/ultraPremiumCircleSvgSrc.svg";
export const vacationSvgSrc = "/svg/gradient/vacation.svg";
export const veganSvgSrc = "/svg/gradient/veganSvgSrc.svg";
export const vipProtectionSvgSrc = "/svg/gradient/vip-protection.svg";
export const waterSvgSrc = "/svg/gradient/water.svg";
export const wheelSvgSrc = "/svg/gradient/wheel.svg";
export const ballsLogoSrc = "/svg/balls.svg";
export const memberOnlyRewardsLogoSrc = "/svg/loyalty/MOR.svg";
export const GuestListSvgSrc = "/svg/loyalty/GuestListSvgSrc.svg";
export const AListSvgSrc = "/svg/loyalty/AListSvgSrc.svg";
export const VIPSvgSrc = "/svg/loyalty/VIPSvgSrc.svg";
export const BirthdaySvgSrc = "/svg/loyalty/BirthdaySvgSrc.svg";
export const CompletedProfileSvgSrc = "/svg/loyalty/CompletedProfileSvgSrc.svg";
export const EarnPointsSvgSrc = "/svg/loyalty/EarnPointSvgSrc.svg";
export const GradientEarnPointsSvgSrc = "/svg/loyalty/GradientEarnPointsSvgSrc.svg";
export const FacebookSvgSrc = "/svg/loyalty/FacebookSvgSrc.svg";
export const FBCommunitySvgSrc = "/svg/loyalty/FBCommunitySvgSrc.svg";
export const InstagramSvgSrc = "/svg/loyalty/InstagramSvgSrc.svg";
export const ReviewSvgSrc = "/svg/loyalty/ReviewSvgSrc.svg";
export const SurveySvgSrc = "/svg/loyalty/SurveySvgSrc.svg";
export const TikTokSvgSrc = "/svg/loyalty/TikTokSvgSrc.svg";
export const YoutubeSvgSrc = "/svg/loyalty/YoutubeSvgSrc.svg";
export const GradientBirthdaySvgSrc = "/svg/loyalty/GradientBirthdaySvgSrc.svg";
export const GradientCompletedProfileSvgSrc = "/svg/loyalty/GradientCompletedProfileSvgSrc.svg";
export const GradientFacebookSvgSrc = "/svg/loyalty/GradientFacebookSvgSrc.svg";
export const GradientFBCommunitySvgSrc = "/svg/loyalty/GradientFBCommunitySvgSrc.svg";
export const GradientInstagramSvgSrc = "/svg/loyalty/GradientInstagramSvgSrc.svg";
export const GradientReviewSvgSrc = "/svg/loyalty/GradientReviewSvgSrc.svg";
export const GradientSurveySvgSrc = "/svg/loyalty/GradientSurveySvgSrc.svg";
export const GradientTikTokSvgSrc = "/svg/loyalty/GradientTikTokSvgSrc.svg";
export const GradientVIPSvgSrc = "/svg/loyalty/GradientVIPSvgSrc.svg";
export const GradientYoutubeSvgSrc = "/svg/loyalty/GradientYoutubeSvgSrc.svg";
export const uploadSvgSrc = "/svg/loyalty/UploadSvgSrc.svg";
export const morCrownSvgSrc = "/svg/loyalty/morCrownSvgSrc.svg";
export const closedQuoteSvgSrc = "/svg/misc/closed-quote.svg";
export const membersOnlyBlackSvgSrc = "/svg/misc/members-only-black.svg";
export const membersOnlyLogoSvgSrc = "/svg/misc/MOLogo.svg";
export const membersOnlyRewardsSvgSrc = "/svg/misc/members-only-rewards.svg";
export const moneyBackDeSvgSrc = "/svg/misc/money-back-de.svg";
export const moneyBackEsSvgSrc = "/svg/misc/money-back-es.svg";
export const moneyBackFrSvgSrc = "/svg/misc/money-back-fr.svg";
export const moneyBackSvgSrc = "/svg/misc/money-back.svg";
export const msTcsSvgSrc = "/svg/misc/ms-tcs.svg";
export const openQuoteSvgSrc = "/svg/misc/open-quote.svg";
export const secureIconSvgSrc = "/svg/misc/secure-icon.svg";
export const weSaveBallsSvgSrc = "/svg/misc/we-save-balls.svg";
export const aListGradientSvgSrc = "/svg/mor/gradient/a-list-gradient.svg";
export const birthdayGradientSvgSrc = "/svg/mor/gradient/birthday-gradient.svg";
export const birthdayGiftGradientSvgSrc = "/svg/mor/gradient/birthday-gift-gradient.svg";
export const completedProfileGradientSvgSrc = "/svg/mor/gradient/completed-profile-gradient.svg";
export const currentPointsGradientSvgSrc = "/svg/mor/gradient/current-points-gradient.svg";
export const earlyAccessGradientSvgSrc = "/svg/mor/gradient/early-access-gradient.svg";
export const earnGradientSvgSrc = "/svg/mor/gradient/earn-gradient.svg";
export const earnPointsGradientSvgSrc = "/svg/mor/gradient/earn-points-gradient.svg";
export const facebookGradientSvgSrc = "/svg/mor/gradient/facebook-gradient.svg";
export const fbCommunityGradientSvgSrc = "/svg/mor/gradient/fb-community-gradient.svg";
export const freeGiftGradientSvgSrc = "/svg/mor/gradient/free-gift-gradient.svg";
export const freeProductGradientSvgSrc = "/svg/mor/gradient/free-product-gradient.svg";
export const guestListGradientSvgSrc = "/svg/mor/gradient/guest-list-gradient.svg";
export const historyGradientSvgSrc = "/svg/mor/gradient/history-gradient.svg";
export const instagramGradientSvgSrc = "/svg/mor/gradient/instagram-gradient.svg";
export const joinGradientSvgSrc = "/svg/mor/gradient/join-gradient.svg";
export const lifetimePointsGradientSvgSrc = "/svg/mor/gradient/lifetime-points-gradient.svg";
export const loyaltyGiftGradientSvgSrc = "/svg/mor/gradient/loyalty-gift-gradient.svg";
export const manniversaryGiftGradientSvgSrc = "/svg/mor/gradient/manniversary-gift-gradient.svg";
export const nextVipPackageGradientSvgSrc = "/svg/mor/gradient/next-vip-package-gradient.svg";
export const otherReplenishmentsGradientSvgSrc = "/svg/mor/gradient/other-replenishments-gradient.svg";
export const pendingPointsGradientSvgSrc = "/svg/mor/gradient/pending-points-gradient.svg";
export const reviewGradientSvgSrc = "/svg/mor/gradient/review-gradient.svg";
export const scoreBonusPointsGradientSvgSrc = "/svg/mor/gradient/score-bonus-points-gradient.svg";
export const shaveGradientSvgSrc = "/svg/mor/gradient/shave-gradient.svg";
export const surveyGradientSvgSrc = "/svg/mor/gradient/survey-gradient.svg";
export const tenRewardsCashGradientSvgSrc = "/svg/mor/gradient/10-rewards-cash-gradient.svg";
export const tiktokGradientSvgSrc = "/svg/mor/gradient/tiktok-gradient.svg";
export const uploadGradientSvgSrc = "/svg/mor/gradient/upload-gradient.svg";
export const vipGradientSvgSrc = "/svg/mor/gradient/vip-gradient.svg";
export const vipPackagePerksGradientSvgSrc = "/svg/mor/gradient/vip-package-perks-gradient.svg";
export const vipPriceGradientSvgSrc = "/svg/mor/gradient/vip-price-gradient.svg";
export const vipProtectionGradientSvgSrc = "/svg/mor/gradient/vip-protection-gradient.svg";
export const youtubeGradientSvgSrc = "/svg/mor/gradient/youtube-gradient.svg";
export const birthdayGreySvgSrc = "/svg/mor/grey/birthday-grey.svg";
export const completedProfileGreySvgSrc = "/svg/mor/grey/completed-profile-grey.svg";
export const earnPointsGreySvgSrc = "/svg/mor/grey/earn-points-grey.svg";
export const facebookGreySvgSrc = "/svg/mor/grey/facebook-grey.svg";
export const fbCommunityGreySvgSrc = "/svg/mor/grey/fb-community-grey.svg";
export const instagramGreySvgSrc = "/svg/mor/grey/instagram-grey.svg";
export const reviewGreySvgSrc = "/svg/mor/grey/review-grey.svg";
export const surveyGreySvgSrc = "/svg/mor/grey/survey-grey.svg";
export const tiktokGreySvgSrc = "/svg/mor/grey/tiktok-grey.svg";
export const youtubeGreySvgSrc = "/svg/mor/grey/youtube-grey.svg";
export const appearanceSvgSrc = "/svg/original-products/appearance.svg";
export const appearanceGoldSvgSrc = "/svg/original-products/appearance-gold.svg";
export const attractivenessSvgSrc = "/svg/original-products/attractiveness.svg";
export const attractivenessGoldSvgSrc = "/svg/original-products/attractiveness-gold.svg";
export const balanceScaleSvgSrc = "/svg/original-products/balance-scale.svg";
export const bestProductSvgSrc = "/svg/original-products/best-product.svg";
export const betterProductSvgSrc = "/svg/original-products/better-product.svg";
export const bladeOldSvgSrc = "/svg/original-products/blade-old.svg";
export const broomSvgSrc = "/svg/original-products/broom.svg";
export const bubblesSvgSrc = "/svg/original-products/bubbles.svg";
export const capitalMSvgSrc = "/svg/original-products/capital-m.svg";
export const cleanHandSvgSrc = "/svg/original-products/clean-hand.svg";
export const clockSvgSrc = "/svg/original-products/clock.svg";
export const clockOldSvgSrc = "/svg/original-products/clock-old.svg";
export const cloudsSvgSrc = "/svg/original-products/clouds.svg";
export const confidenceSvgSrc = "/svg/original-products/confidence.svg";
export const confidenceGoldSvgSrc = "/svg/original-products/confidence-gold.svg";
export const diamondsSvgSrc = "/svg/original-products/diamonds.svg";
export const dnaSvgSrc = "/svg/original-products/dna.svg";
export const driesClearOldSvgSrc = "/svg/original-products/dries-clear-old.svg";
export const fabricSvgSrc = "/svg/original-products/fabric.svg";
export const fanSvgSrc = "/svg/original-products/fan.svg";
export const fireSvgSrc = "/svg/original-products/fire.svg";
export const footShieldSvgSrc = "/svg/original-products/foot-shield.svg";
export const goodProductSvgSrc = "/svg/original-products/good-product.svg";
export const hairSvgSrc = "/svg/original-products/hair.svg";
export const highVisibilityBlackSvgSrc = "/svg/original-products/high-visibility.svg";
export const hygieneSvgSrc = "/svg/original-products/hygiene.svg";
export const hygieneGoldSvgSrc = "/svg/original-products/hygiene-gold.svg";
export const moisturizerSvgSrc = "/svg/original-products/moisturizer.svg";
export const protractorSvgSrc = "/svg/original-products/protractor.svg";
export const smileSvgSrc = "/svg/original-products/smile.svg";
export const suitcaseTagSvgSrc = "/svg/original-products/suitcase-tag.svg";
export const twoInOneDarkSvgSrc = "/svg/original-products/two-in-one-dark.svg";
export const ultraPremiumTextSvgSrc = "/svg/original-products/ultra-premium-text.svg";
export const ultraPremiumTextDarkSvgSrc = "/svg/original-products/ultra-premium-text-dark.svg";
export const waterArmorSvgSrc = "/svg/original-products/water-armor.svg";
export const waterPuddleSvgSrc = "/svg/original-products/water-puddle.svg";
export const waterShieldSvgSrc = "/svg/original-products/water-shield.svg";
export const waterWashSvgSrc = "/svg/original-products/water-wash.svg";
export const amexLogoSvgSrc = "/svg/payment-methods/amex-logo.svg";
export const amexLogoWhiteSvgSrc = "/svg/payment-methods/amex-logo-white.svg";
export const applePayLogoSvgSrc = "/svg/payment-methods/apple-pay-logo.svg";
export const applePayLogoCardSvgSrc = "/svg/payment-methods/apple-pay-logo-card.svg";
export const banContactLogoSvgSrc = "/svg/payment-methods/ban-contact-logo.svg";
export const creditCardLogoSvgSrc = "/svg/payment-methods/credit-card.svg";
export const dinersLogoSvgSrc = "/svg/payment-methods/diners-logo.svg";
export const dinersLogoWhiteSvgSrc = "/svg/payment-methods/diners-logo-white.svg";
export const discoverLogoSvgSrc = "/svg/payment-methods/discover-logo.svg";
export const discoverLogoWhiteSvgSrc = "/svg/payment-methods/discover-logo-white.svg";
export const googlePayLogoSvgSrc = "/svg/payment-methods/google-pay-logo.svg";
export const iDealLogoSvgSrc = "/svg/payment-methods/i-deal-logo.svg";
export const jcbLogoSvgSrc = "/svg/payment-methods/jcb-logo.svg";
export const jcbLogoWhiteSvgSrc = "/svg/payment-methods/jcb-logo-white.svg";
export const klarnaLogoSvgSrc = "/svg/payment-methods/klarna.svg";
export const klarnaWhiteLogoSvgSrc = "/svg/payment-methods/klarna-white.svg";
export const maestroLogoSvgSrc = "/svg/payment-methods/maestro-logo.svg";
export const masterCardLogoSvgSrc = "/svg/payment-methods/mastercard-logo.svg";
export const masterCardLogoWhiteSvgSrc = "/svg/payment-methods/mastercard-logo-white.svg";
export const paypalLogoSvgSrc = "/svg/payment-methods/paypal-logo.svg";
export const paypalLogoBlueSvgSrc = "/svg/payment-methods/paypal-blue.svg";
export const paypalLogoWhiteSvgSrc = "/svg/payment-methods/paypal-white.svg";
export const paypalLogoBgSvgSrc = "/svg/payment-methods/paypal-blue-w-bg.svg";
export const paypalLogoGraySvgSrc = "/svg/payment-methods/paypal-gray.svg";
export const paypalLogoShortSvgSrc = "/svg/payment-methods/paypal-logo-short.svg";
export const paypalLogoWhiteIconSvgSrc = "/svg/payment-methods/paypal-icon-logo-white.svg";
export const paypalLogoWhiteMarkSvgSrc = "/svg/payment-methods/paypal-white-w-mark.svg";
export const shopPayLogoSvgSrc = "/svg/payment-methods/shop-pay-logo.svg";
export const shopPayLogoBlackSvgSrc = "/svg/payment-methods/shop-pay-logo-black.svg";
export const shopPayLogoWhiteSvgSrc = "/svg/payment-methods/shop-pay-logo-white.svg";
export const venmoLogoSvgSrc = "/svg/payment-methods/venmo-logo.svg";
export const venmoMarkSvgSrc = "/svg/payment-methods/venmo-mark.svg";
export const venmoMarkGraySvgSrc = "/svg/payment-methods/venmo-mark-gray.svg";
export const visaLogoSvgSrc = "/svg/payment-methods/visa-logo.svg";
export const visaLogoWhiteSvgSrc = "/svg/payment-methods/visa-logo-white.svg";
export const visaLogoBlueSvgSrc = "/svg/payment-methods/visa-logo-blue.svg";
export const unionPayLogoSvgSrc = "/svg/payment-methods/unionpay-logo.svg";
export const tcsQuoteSvgSrc = "/svg/tcs/quote.svg";
export const tcsQuoteWhiteSvgSrc = "/svg/tcs/quote-white.svg";
export const tcsDonateSvgSrc = "/svg/tcs/icon-tcs-donate.svg";
export const tcsHeartBubbleSvgSrc = "/svg/tcs/icon-tcs-heart-bubble.svg";
export const tcsIconSvgSrc = "/svg/tcs/icon-tcs.svg";
export const tcsLogoSvgSrc = "/svg/tcs/tcs-logo.svg";
export const tcsSpecialOfferSrc = "/svg/tcs/tcs-special-offer.svg";
export const tcsSpecialOfferOosSrc = "/svg/tcs/tcs-special-offer-oos.svg";
export const aMinuteWhiteSvgSrc = "/svg/white/aMinuteWhiteSvgSrc.svg";
export const antibacterialSiliconeWhiteSvgSrc = "/svg/white/antibacterialSiliconeWhiteSvgSrc.svg";
export const chargeTimeWhiteSvgSrc = "/svg/white/chargeTimeWhiteSvgSrc.svg";
export const dualHeadSystemWhiteSvgSrc = "/svg/white/dualHeadSystemWhiteSvgSrc.svg";
export const goodCuticlesWhiteSvgSrc = "/svg/white/good-cuticles-white.svg";
export const illuminateHydrateWhiteSvgSrc = "/svg/white/illuminateHydrateWhiteSvgSrc.svg";
export const medicalWhiteSvgSrc = "/svg/white/medicalWhiteSvgSrc.svg";
export const multiGlideWhiteSvgSrc = "/svg/white/multiGlideWhiteSvgSrc.svg";
export const pencilWhiteSvgSrc = "/svg/white/pencilWhiteSvgSrc.svg";
export const premiumHydrationWhiteSvgSrc = "/svg/white/premiumHydrationWhiteSvgSrc.svg";
export const sonicCleanWhiteSvgSrc = "/svg/white/sonicCleanWhiteSvgSrc.svg";
export const spotlightWhiteSvgSrc = "/svg/white/spotlightWhiteSvgSrc.svg";
export const waterWhiteSvgSrc = "/svg/white/waterWhiteSvgSrc.svg";

export const allSvgSrcs = {
  addedProtectionBlackSvgSrc: "/svg/black/addedProtectionBlackSvgSrc.svg",
  buffBlackSvgSrc: "/svg/black/buffBlackSvgSrc.svg",
  deepHydrationBlackSvgSrc: "/svg/black/deepHydrationBlackSvgSrc.svg",
  dualHeadSystemBlackSvgSrc: "/svg/black/dualHeadSystemBlackSvgSrc.svg",
  fileEdgeBlackSvgSrc: "/svg/black/file-edge-black.svg",
  ingrownHairBlackSvgSrc: "/svg/black/ingrownHairBlackSvgSrc.svg",
  innovatorsBlackSvgSrc: "/svg/black/innovatorsBlackSvgSrc.svg",
  lawnMowerBlackSvgSrc: "/svg/black/lawnMowerBlackSvgSrc.svg",
  leaveShineBlackSvgSrc: "/svg/black/leaveShineBlackSvgSrc.svg",
  lubricationBlackSvgSrc: "/svg/black/lubricationBlackSvgSrc.svg",
  multiGlideBlackSvgSrc: "/svg/black/multiGlideBlackSvgSrc.svg",
  noOuchBlackSvgSrc: "/svg/black/noOuchBlackSvgSrc.svg",
  publicPrivatesBlackSvgSrc: "/svg/black/publicPrivatesBlackSvgSrc.svg",
  satinWaistbandBlackSvgSrc: "/svg/black/satinWaistbandBlackSvgSrc.svg",
  setVibeBlackSvgSrc: "/svg/black/setVibeBlackSvgSrc.svg",
  skinsafeBlackSvgSrc: "/svg/black/skinsafeBlackSvgSrc.svg",
  trustedBlackSvgSrc: "/svg/black/trustedBlackSvgSrc.svg",
  waterBlackSvgSrc: "/svg/black/waterBlackSvgSrc.svg",
  allureLogoSvgSrc: "/svg/company-logos/allureLogoSvgSrc.svg",
  esquireLogoSvgSrc: "/svg/company-logos/esquireLogoSvgSrc.svg",
  forbesLogoSvgSrc: "/svg/company-logos/forbesLogoSvgSrc.svg",
  glamourLogoSvgSrc: "/svg/company-logos/glamourLogoSvgSrc.svg",
  gqLogoSvgSrc: "/svg/company-logos/gqLogoSvgSrc.svg",
  mensHealthLogoSvgSrc: "/svg/company-logos/menshealthLogoSvgSrc.svg",
  wiredLogoSvgSrc: "/svg/company-logos/wiredLogoSvgSrc.svg",
  detachablePadSvgSrc: "/svg/dome-care/detachablePadSvgSrc.svg",
  glowingSvgSrc: "/svg/dome-care/glowingSvgSrc.svg",
  padLubricationSvgSrc: "/svg/dome-care/padLubricationSvgSrc.svg",
  palmItSvgSrc: "/svg/dome-care/palmItSvgSrc.svg",
  smoothFinishSvgSrc: "/svg/dome-care/smoothFinishSvgSrc.svg",
  sootheGroovesSvgSrc: "/svg/dome-care/sootheGroovesSvgSrc.svg",
  sootheOperatorSvgSrc: "/svg/dome-care/sootheOperatorSvgSrc.svg",
  glassdoorLogoSrc: "/svg/featured/glassdoor.svg",
  studentBeansLogoSrc: "/svg/featured/student-beans.svg",
  unidaysLogoSrc: "/svg/featured/unidays.svg",
  auFlagSvgSrc: "/svg/flags/au.svg",
  caFlagSvgSrc: "/svg/flags/ca.svg",
  euFlagSvgSrc: "/svg/flags/eu.svg",
  sgFlagSvgSrc: "/svg/flags/sg.svg",
  ukFlagSvgSrc: "/svg/flags/uk.svg",
  usFlagSvgSrc: "/svg/flags/us.svg",
  zaFlagSvgSrc: "/svg/flags/za.svg",
  aMinuteSvgSrc: "/svg/gradient/aMinuteSvgSrc.svg",
  addedProtectionSvgSrc: "/svg/gradient/added-protection.svg",
  alcoholFreeSvgSrc: "/svg/gradient/alcoholFreeSvgSrc.svg",
  aluminumFreeSvgSrc: "/svg/gradient/aluminum-free.svg",
  antibacterialSiliconeSvgSrc: "/svg/gradient/antibacterialSiliconeSvgSrc.svg",
  batterySvgSrc: "/svg/gradient/battery.svg",
  bladesAltSvgSrc: "/svg/gradient/blades-alt.svg",
  bladesSvgSrc: "/svg/gradient/blades.svg",
  buffSvgSrc: "/svg/gradient/buff.svg",
  calendarSvgSrc: "/svg/gradient/calendar.svg",
  chargeTimeSvgSrc: "/svg/gradient/charge-time.svg",
  cleanSvgSrc: "/svg/gradient/cleanSvgSrc.svg",
  clearYourHeadSvgSrc: "/svg/gradient/clear-your-head.svg",
  clippersSvgSrc: "/svg/gradient/clippers.svg",
  cologneQualitySvgSrc: "/svg/gradient/cologne-quality.svg",
  confirmationSvgSrc: "/svg/gradient/confirmationSvgSrc.svg",
  crownSvgSrc: "/svg/gradient/crown.svg",
  crueltyFreeSvgSrc: "/svg/gradient/cruelty-free.svg",
  currentPointsSvgSrc: "/svg/gradient/current-points.svg",
  deepHydrationSvgSrc: "/svg/gradient/deep-hydration.svg",
  dermatologistTestedSvgSrc: "/svg/gradient/dermatologistTestedSvgSrc.svg",
  detailSvgSrc: "/svg/gradient/detail.svg",
  discountSvgSrc: "/svg/gradient/discount.svg",
  dollarSvgSrc: "/svg/gradient/dollar.svg",
  driesClearSvgSrc: "/svg/gradient/dries-clear.svg",
  dualHeadSystemSvgSrc: "/svg/gradient/dualHeadSystemSvgSrc.svg",
  dualSvgSrc: "/svg/gradient/dual.svg",
  dyeFreeSvgSrc: "/svg/gradient/dye-free.svg",
  engraveSvgSrc: "/svg/gradient/engrave.svg",
  exfoliationSvgSrc: "/svg/gradient/exfoliation.svg",
  featherSvgSrc: "/svg/gradient/feather.svg",
  fileEdgeSvgSrc: "/svg/gradient/fileEdgeSvgSrc.svg",
  financeSvgSrc: "/svg/gradient/finance.svg",
  frontFlySvgSrc: "/svg/gradient/front-fly.svg",
  gearGradientSvgSrc: "/svg/gradient/gear.svg",
  goodCuticlesSvgSrc: "/svg/gradient/goodCuticlesSvgSrc.svg",
  gradientRingSvgSrc: "/svg/gradient/gradient-ring.svg",
  groomOnGoSvgSrc: "/svg/gradient/groom-on-go.svg",
  highVisibilitySvgSrc: "/svg/gradient/high-visibility.svg",
  HistorySvgSrc: "/svg/gradient/HistorySvgSrc.svg",
  holidaySvgSrc: "/svg/gradient/holiday.svg",
  ingrownHairSvgSrc: "/svg/gradient/ingrown-hair.svg",
  insuranceSvgSrc: "/svg/gradient/insurance.svg",
  jewelPouchSvgSrc: "/svg/gradient/jewel-pouch.svg",
  latherSvgSrc: "/svg/gradient/lux-lather.svg",
  liIonCircleSvgSrc: "/svg/gradient/li-ion-circle.svg",
  lifetimePointsSvgSrc: "/svg/gradient/lifetime-points.svg",
  lm5FoilBladeSvgSrc: "/svg/gradient/lm5-foil-blade.svg",
  lm5TrimmerBladeSvgSrc: "/svg/gradient/lm5-trimmer-blade.svg",
  lockSvgSrc: "/svg/gradient/icon-lock.svg",
  lubricationSvgSrc: "/svg/gradient/lubrication.svg",
  magnetSvgSrc: "/svg/gradient/magnet.svg",
  medicalSvgSrc: "/svg/gradient/medical.svg",
  mentalHealthSvgSrc: "/svg/gradient/mental-health.svg",
  messageSvgSrc: "/svg/gradient/message.svg",
  microCombSvgSrc: "/svg/gradient/micro-comb.svg",
  microFabricSvgSrc: "/svg/gradient/micro-fabric.svg",
  multiGlideSvgSrc: "/svg/gradient/multi-glide.svg",
  noGermsSvgSrc: "/svg/gradient/no-germs.svg",
  nonGreasyFormulaSvgSrc: "/svg/gradient/nonGreasyFormulaSvgSrc.svg",
  noOuchSvgSrc: "/svg/gradient/no-ouch.svg",
  oneStrokeSvgSrc: "/svg/gradient/one-stroke.svg",
  otherReplenishmentsSvgSrc: "/svg/gradient/otherReplenishmentsSvgSrc.svg",
  parabenFreeSvgSrc: "/svg/gradient/parabenFreeSvgSrc.svg",
  pendingPointsSvgSrc: "/svg/gradient/pending-points.svg",
  pencilSvgSrc: "/svg/gradient/pencil.svg",
  persevereSvgSrc: "/svg/gradient/persevere.svg",
  pivotSvgSrc: "/svg/gradient/pivot.svg",
  polishSvgSrc: "/svg/gradient/polish.svg",
  precision2SvgSrc: "/svg/gradient/precision2.svg",
  premiumHydrationSvgSrc: "/svg/gradient/premiumHydrationSvgSrc.svg",
  presentSvgSrc: "/svg/gradient/present.svg",
  refreshRootsSvgSrc: "/svg/gradient/refresh-roots.svg",
  refreshSvgSrc: "/svg/gradient/refresh.svg",
  refinedSvgSrc: "/svg/gradient/refined.svg",
  satinWaistbandSvgSrc: "/svg/gradient/satin-waistband.svg",
  setVibeSvgSrc: "/svg/gradient/setVibeSvgSrc.svg",
  shippingSvgSrc: "/svg/gradient/shipping.svg",
  sickLeaveSvgSrc: "/svg/gradient/sick-leave.svg",
  signatureScentSvgSrc: "/svg/gradient/signature-scent.svg",
  skinToneSvgSrc: "/svg/gradient/skinToneSvgSrc.svg",
  skincareKitsSvgSrc: "/svg/gradient/skincareKitsSvgSrc.svg",
  skinsafeSvgSrc: "/svg/gradient/skinsafe.svg",
  smileHeartSvgSrc: "/svg/gradient/smile-heart.svg",
  sonicCleanSvgSrc: "/svg/gradient/sonicCleanSvgSrc.svg",
  spiralSvgSrc: "/svg/gradient/spiral.svg",
  spotlightSvgSrc: "/svg/gradient/icon-spotlight.svg",
  steelSvgSrc: "/svg/gradient/steel.svg",
  sulfateFreeSvgSrc: "/svg/gradient/sulfateFreeSvgSrc.svg",
  titaniumSvgSrc: "/svg/gradient/titanium.svg",
  toolCaseSvgSrc: "/svg/gradient/tool-case.svg",
  trophySvgSrc: "/svg/gradient/trophy.svg",
  tweezerSvgSrc: "/svg/gradient/tweezer.svg",
  twoInOneSvgSrc: "/svg/gradient/two-in-one.svg",
  ultraPremiumSvgSrc: "/svg/gradient/ultra-premium.svg",
  ultraPremiumCircleSvgSrc: "/svg/gradient/ultraPremiumCircleSvgSrc.svg",
  vacationSvgSrc: "/svg/gradient/vacation.svg",
  veganSvgSrc: "/svg/gradient/veganSvgSrc.svg",
  vipProtectionSvgSrc: "/svg/gradient/vip-protection.svg",
  waterSvgSrc: "/svg/gradient/water.svg",
  wheelSvgSrc: "/svg/gradient/wheel.svg",
  ballsLogoSrc: "/svg/balls.svg",
  memberOnlyRewardsLogoSrc: "/svg/loyalty/MOR.svg",
  GuestListSvgSrc: "/svg/loyalty/GuestListSvgSrc.svg",
  AListSvgSrc: "/svg/loyalty/AListSvgSrc.svg",
  VIPSvgSrc: "/svg/loyalty/VIPSvgSrc.svg",
  BirthdaySvgSrc: "/svg/loyalty/BirthdaySvgSrc.svg",
  CompletedProfileSvgSrc: "/svg/loyalty/CompletedProfileSvgSrc.svg",
  EarnPointsSvgSrc: "/svg/loyalty/EarnPointSvgSrc.svg",
  GradientEarnPointsSvgSrc: "/svg/loyalty/GradientEarnPointsSvgSrc.svg",
  FacebookSvgSrc: "/svg/loyalty/FacebookSvgSrc.svg",
  FBCommunitySvgSrc: "/svg/loyalty/FBCommunitySvgSrc.svg",
  InstagramSvgSrc: "/svg/loyalty/InstagramSvgSrc.svg",
  ReviewSvgSrc: "/svg/loyalty/ReviewSvgSrc.svg",
  SurveySvgSrc: "/svg/loyalty/SurveySvgSrc.svg",
  TikTokSvgSrc: "/svg/loyalty/TikTokSvgSrc.svg",
  YoutubeSvgSrc: "/svg/loyalty/YoutubeSvgSrc.svg",
  GradientBirthdaySvgSrc: "/svg/loyalty/GradientBirthdaySvgSrc.svg",
  GradientCompletedProfileSvgSrc: "/svg/loyalty/GradientCompletedProfileSvgSrc.svg",
  GradientFacebookSvgSrc: "/svg/loyalty/GradientFacebookSvgSrc.svg",
  GradientFBCommunitySvgSrc: "/svg/loyalty/GradientFBCommunitySvgSrc.svg",
  GradientInstagramSvgSrc: "/svg/loyalty/GradientInstagramSvgSrc.svg",
  GradientReviewSvgSrc: "/svg/loyalty/GradientReviewSvgSrc.svg",
  GradientSurveySvgSrc: "/svg/loyalty/GradientSurveySvgSrc.svg",
  GradientTikTokSvgSrc: "/svg/loyalty/GradientTikTokSvgSrc.svg",
  GradientVIPSvgSrc: "/svg/loyalty/GradientVIPSvgSrc.svg",
  GradientYoutubeSvgSrc: "/svg/loyalty/GradientYoutubeSvgSrc.svg",
  uploadSvgSrc: "/svg/loyalty/UploadSvgSrc.svg",
  morCrownSvgSrc: "/svg/loyalty/morCrownSvgSrc.svg",
  closedQuoteSvgSrc: "/svg/misc/closed-quote.svg",
  membersOnlyBlackSvgSrc: "/svg/misc/members-only-black.svg",
  membersOnlyLogoSvgSrc: "/svg/misc/MOLogo.svg",
  membersOnlyRewardsSvgSrc: "/svg/misc/members-only-rewards.svg",
  moneyBackDeSvgSrc: "/svg/misc/money-back-de.svg",
  moneyBackEsSvgSrc: "/svg/misc/money-back-es.svg",
  moneyBackFrSvgSrc: "/svg/misc/money-back-fr.svg",
  moneyBackSvgSrc: "/svg/misc/money-back.svg",
  msTcsSvgSrc: "/svg/misc/ms-tcs.svg",
  openQuoteSvgSrc: "/svg/misc/open-quote.svg",
  secureIconSvgSrc: "/svg/misc/secure-icon.svg",
  weSaveBallsSvgSrc: "/svg/misc/we-save-balls.svg",
  aListGradientSvgSrc: "/svg/mor/gradient/a-list-gradient.svg",
  birthdayGradientSvgSrc: "/svg/mor/gradient/birthday-gradient.svg",
  birthdayGiftGradientSvgSrc: "/svg/mor/gradient/birthday-gift-gradient.svg",
  completedProfileGradientSvgSrc: "/svg/mor/gradient/completed-profile-gradient.svg",
  currentPointsGradientSvgSrc: "/svg/mor/gradient/current-points-gradient.svg",
  earlyAccessGradientSvgSrc: "/svg/mor/gradient/early-access-gradient.svg",
  earnGradientSvgSrc: "/svg/mor/gradient/earn-gradient.svg",
  earnPointsGradientSvgSrc: "/svg/mor/gradient/earn-points-gradient.svg",
  facebookGradientSvgSrc: "/svg/mor/gradient/facebook-gradient.svg",
  fbCommunityGradientSvgSrc: "/svg/mor/gradient/fb-community-gradient.svg",
  freeGiftGradientSvgSrc: "/svg/mor/gradient/free-gift-gradient.svg",
  freeProductGradientSvgSrc: "/svg/mor/gradient/free-product-gradient.svg",
  guestListGradientSvgSrc: "/svg/mor/gradient/guest-list-gradient.svg",
  historyGradientSvgSrc: "/svg/mor/gradient/history-gradient.svg",
  instagramGradientSvgSrc: "/svg/mor/gradient/instagram-gradient.svg",
  joinGradientSvgSrc: "/svg/mor/gradient/join-gradient.svg",
  lifetimePointsGradientSvgSrc: "/svg/mor/gradient/lifetime-points-gradient.svg",
  loyaltyGiftGradientSvgSrc: "/svg/mor/gradient/loyalty-gift-gradient.svg",
  manniversaryGiftGradientSvgSrc: "/svg/mor/gradient/manniversary-gift-gradient.svg",
  nextVipPackageGradientSvgSrc: "/svg/mor/gradient/next-vip-package-gradient.svg",
  otherReplenishmentsGradientSvgSrc: "/svg/mor/gradient/other-replenishments-gradient.svg",
  pendingPointsGradientSvgSrc: "/svg/mor/gradient/pending-points-gradient.svg",
  reviewGradientSvgSrc: "/svg/mor/gradient/review-gradient.svg",
  scoreBonusPointsGradientSvgSrc: "/svg/mor/gradient/score-bonus-points-gradient.svg",
  shaveGradientSvgSrc: "/svg/mor/gradient/shave-gradient.svg",
  surveyGradientSvgSrc: "/svg/mor/gradient/survey-gradient.svg",
  tenRewardsCashGradientSvgSrc: "/svg/mor/gradient/10-rewards-cash-gradient.svg",
  tiktokGradientSvgSrc: "/svg/mor/gradient/tiktok-gradient.svg",
  uploadGradientSvgSrc: "/svg/mor/gradient/upload-gradient.svg",
  vipGradientSvgSrc: "/svg/mor/gradient/vip-gradient.svg",
  vipPackagePerksGradientSvgSrc: "/svg/mor/gradient/vip-package-perks-gradient.svg",
  vipPriceGradientSvgSrc: "/svg/mor/gradient/vip-price-gradient.svg",
  vipProtectionGradientSvgSrc: "/svg/mor/gradient/vip-protection-gradient.svg",
  youtubeGradientSvgSrc: "/svg/mor/gradient/youtube-gradient.svg",
  birthdayGreySvgSrc: "/svg/mor/grey/birthday-grey.svg",
  completedProfileGreySvgSrc: "/svg/mor/grey/completed-profile-grey.svg",
  earnPointsGreySvgSrc: "/svg/mor/grey/earn-points-grey.svg",
  facebookGreySvgSrc: "/svg/mor/grey/facebook-grey.svg",
  fbCommunityGreySvgSrc: "/svg/mor/grey/fb-community-grey.svg",
  instagramGreySvgSrc: "/svg/mor/grey/instagram-grey.svg",
  reviewGreySvgSrc: "/svg/mor/grey/review-grey.svg",
  surveyGreySvgSrc: "/svg/mor/grey/survey-grey.svg",
  tiktokGreySvgSrc: "/svg/mor/grey/tiktok-grey.svg",
  youtubeGreySvgSrc: "/svg/mor/grey/youtube-grey.svg",
  appearanceSvgSrc: "/svg/original-products/appearance.svg",
  appearanceGoldSvgSrc: "/svg/original-products/appearance-gold.svg",
  attractivenessSvgSrc: "/svg/original-products/attractiveness.svg",
  attractivenessGoldSvgSrc: "/svg/original-products/attractiveness-gold.svg",
  balanceScaleSvgSrc: "/svg/original-products/balance-scale.svg",
  bestProductSvgSrc: "/svg/original-products/best-product.svg",
  betterProductSvgSrc: "/svg/original-products/better-product.svg",
  bladeOldSvgSrc: "/svg/original-products/blade-old.svg",
  broomSvgSrc: "/svg/original-products/broom.svg",
  bubblesSvgSrc: "/svg/original-products/bubbles.svg",
  capitalMSvgSrc: "/svg/original-products/capital-m.svg",
  cleanHandSvgSrc: "/svg/original-products/clean-hand.svg",
  clockSvgSrc: "/svg/original-products/clock.svg",
  clockOldSvgSrc: "/svg/original-products/clock-old.svg",
  cloudsSvgSrc: "/svg/original-products/clouds.svg",
  confidenceSvgSrc: "/svg/original-products/confidence.svg",
  confidenceGoldSvgSrc: "/svg/original-products/confidence-gold.svg",
  diamondsSvgSrc: "/svg/original-products/diamonds.svg",
  dnaSvgSrc: "/svg/original-products/dna.svg",
  driesClearOldSvgSrc: "/svg/original-products/dries-clear-old.svg",
  fabricSvgSrc: "/svg/original-products/fabric.svg",
  fanSvgSrc: "/svg/original-products/fan.svg",
  fireSvgSrc: "/svg/original-products/fire.svg",
  footShieldSvgSrc: "/svg/original-products/foot-shield.svg",
  goodProductSvgSrc: "/svg/original-products/good-product.svg",
  hairSvgSrc: "/svg/original-products/hair.svg",
  highVisibilityBlackSvgSrc: "/svg/original-products/high-visibility.svg",
  hygieneSvgSrc: "/svg/original-products/hygiene.svg",
  hygieneGoldSvgSrc: "/svg/original-products/hygiene-gold.svg",
  moisturizerSvgSrc: "/svg/original-products/moisturizer.svg",
  protractorSvgSrc: "/svg/original-products/protractor.svg",
  smileSvgSrc: "/svg/original-products/smile.svg",
  suitcaseTagSvgSrc: "/svg/original-products/suitcase-tag.svg",
  twoInOneDarkSvgSrc: "/svg/original-products/two-in-one-dark.svg",
  ultraPremiumTextSvgSrc: "/svg/original-products/ultra-premium-text.svg",
  ultraPremiumTextDarkSvgSrc: "/svg/original-products/ultra-premium-text-dark.svg",
  waterArmorSvgSrc: "/svg/original-products/water-armor.svg",
  waterPuddleSvgSrc: "/svg/original-products/water-puddle.svg",
  waterShieldSvgSrc: "/svg/original-products/water-shield.svg",
  waterWashSvgSrc: "/svg/original-products/water-wash.svg",
  amexLogoSvgSrc: "/svg/payment-methods/amex-logo.svg",
  amexLogoWhiteSvgSrc: "/svg/payment-methods/amex-logo-white.svg",
  applePayLogoSvgSrc: "/svg/payment-methods/apple-pay-logo.svg",
  applePayLogoCardSvgSrc: "/svg/payment-methods/apple-pay-logo-card.svg",
  banContactLogoSvgSrc: "/svg/payment-methods/ban-contact-logo.svg",
  creditCardLogoSvgSrc: "/svg/payment-methods/credit-card.svg",
  dinersLogoSvgSrc: "/svg/payment-methods/diners-logo.svg",
  dinersLogoWhiteSvgSrc: "/svg/payment-methods/diners-logo-white.svg",
  discoverLogoSvgSrc: "/svg/payment-methods/discover-logo.svg",
  discoverLogoWhiteSvgSrc: "/svg/payment-methods/discover-logo-white.svg",
  googlePayLogoSvgSrc: "/svg/payment-methods/google-pay-logo.svg",
  iDealLogoSvgSrc: "/svg/payment-methods/i-deal-logo.svg",
  jcbLogoSvgSrc: "/svg/payment-methods/jcb-logo.svg",
  jcbLogoWhiteSvgSrc: "/svg/payment-methods/jcb-logo-white.svg",
  klarnaLogoSvgSrc: "/svg/payment-methods/klarna.svg",
  klarnaWhiteLogoSvgSrc: "/svg/payment-methods/klarna-white.svg",
  maestroLogoSvgSrc: "/svg/payment-methods/maestro-logo.svg",
  masterCardLogoSvgSrc: "/svg/payment-methods/mastercard-logo.svg",
  masterCardLogoWhiteSvgSrc: "/svg/payment-methods/mastercard-logo-white.svg",
  paypalLogoSvgSrc: "/svg/payment-methods/paypal-logo.svg",
  paypalLogoBlueSvgSrc: "/svg/payment-methods/paypal-blue.svg",
  paypalLogoWhiteSvgSrc: "/svg/payment-methods/paypal-white.svg",
  paypalLogoBgSvgSrc: "/svg/payment-methods/paypal-blue-w-bg.svg",
  paypalLogoGraySvgSrc: "/svg/payment-methods/paypal-gray.svg",
  paypalLogoShortSvgSrc: "/svg/payment-methods/paypal-logo-short.svg",
  paypalLogoWhiteIconSvgSrc: "/svg/payment-methods/paypal-icon-logo-white.svg",
  paypalLogoWhiteMarkSvgSrc: "/svg/payment-methods/paypal-white-w-mark.svg",
  shopPayLogoSvgSrc: "/svg/payment-methods/shop-pay-logo.svg",
  shopPayLogoBlackSvgSrc: "/svg/payment-methods/shop-pay-logo-black.svg",
  shopPayLogoWhiteSvgSrc: "/svg/payment-methods/shop-pay-logo-white.svg",
  venmoLogoSvgSrc: "/svg/payment-methods/venmo-logo.svg",
  venmoMarkSvgSrc: "/svg/payment-methods/venmo-mark.svg",
  venmoMarkGraySvgSrc: "/svg/payment-methods/venmo-mark-gray.svg",
  visaLogoSvgSrc: "/svg/payment-methods/visa-logo.svg",
  visaLogoWhiteSvgSrc: "/svg/payment-methods/visa-logo-white.svg",
  visaLogoBlueSvgSrc: "/svg/payment-methods/visa-logo-blue.svg",
  unionPayLogoSvgSrc: "/svg/payment-methods/unionpay-logo.svg",
  tcsQuoteSvgSrc: "/svg/tcs/quote.svg",
  tcsQuoteWhiteSvgSrc: "/svg/tcs/quote-white.svg",
  tcsDonateSvgSrc: "/svg/tcs/icon-tcs-donate.svg",
  tcsHeartBubbleSvgSrc: "/svg/tcs/icon-tcs-heart-bubble.svg",
  tcsIconSvgSrc: "/svg/tcs/icon-tcs.svg",
  tcsLogoSvgSrc: "/svg/tcs/tcs-logo.svg",
  tcsSpecialOfferSrc: "/svg/tcs/tcs-special-offer.svg",
  tcsSpecialOfferOosSrc: "/svg/tcs/tcs-special-offer-oos.svg",
  aMinuteWhiteSvgSrc: "/svg/white/aMinuteWhiteSvgSrc.svg",
  antibacterialSiliconeWhiteSvgSrc: "/svg/white/antibacterialSiliconeWhiteSvgSrc.svg",
  chargeTimeWhiteSvgSrc: "/svg/white/chargeTimeWhiteSvgSrc.svg",
  dualHeadSystemWhiteSvgSrc: "/svg/white/dualHeadSystemWhiteSvgSrc.svg",
  goodCuticlesWhiteSvgSrc: "/svg/white/good-cuticles-white.svg",
  illuminateHydrateWhiteSvgSrc: "/svg/white/illuminateHydrateWhiteSvgSrc.svg",
  medicalWhiteSvgSrc: "/svg/white/medicalWhiteSvgSrc.svg",
  multiGlideWhiteSvgSrc: "/svg/white/multiGlideWhiteSvgSrc.svg",
  pencilWhiteSvgSrc: "/svg/white/pencilWhiteSvgSrc.svg",
  premiumHydrationWhiteSvgSrc: "/svg/white/premiumHydrationWhiteSvgSrc.svg",
  sonicCleanWhiteSvgSrc: "/svg/white/sonicCleanWhiteSvgSrc.svg",
  spotlightWhiteSvgSrc: "/svg/white/spotlightWhiteSvgSrc.svg",
  waterWhiteSvgSrc: "/svg/white/waterWhiteSvgSrc.svg"
};
export default allSvgSrcs;
